import { IconType } from 'react-icons';
import { FaUserNinja, FaPaw, FaDumbbell, FaCar, FaGuitar, FaPalette, FaTree, FaRocket, FaPhotoFilm } from 'react-icons/fa6';
import { Product } from './ProductManager';

export interface TemplateGroup {
  id: string;           // matches tag value
  name: string;         // display name
  description: string;
  icon: IconType;
  priority: number;     // display order
}

export const TEMPLATE_GROUPS: TemplateGroup[] = [
  {
    id: "action-figures",
    name: "Action Figures",
    description: "Customizable action figure designs",
    icon: FaUserNinja,
    priority: 1
  },
  {
    id: "cartoonize-photo",
    name: "Cartoonize Your Photo",
    description: "Turn your photo into a cartoon",
    icon: FaPhotoFilm,
    priority: 2
  }
];

/**
 * Helper function to get the template group from a product
 * @param template Product object
 * @returns TemplateGroup or null if no matching group found
 */
export const getTemplateGroup = (template: Product): TemplateGroup | null => {
  const primaryTag = template.tags?.[0];
  if (!primaryTag) return null;
  return TEMPLATE_GROUPS.find(g => g.id === primaryTag) || null;
};
